import { SummaryServiceProvider } from './../../../../providers/wh/summary-service';
import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';

import { DatePipe } from '@angular/common';

@Component({
  selector: 'tickets-details-page',
  templateUrl: 'details.html',
  providers: [SummaryServiceProvider]
})
export class TicketDetailPage {
  header_data: any;

  public ticket_id:any;
  public cp_data_obj:any;
  public comment_text:any;

  cp_data: any = "";

  objectKeys = Object.keys;
  constructor(private alertCtrl: AlertController,public navCtrl: NavController, public datepipe: DatePipe, public navParams: NavParams, public summaryService: SummaryServiceProvider, public loadingCtrl: LoadingController) {
    this.header_data = { ismenu: true, ishome: false, title: " Ticket# "+this.navParams.get('ticket_id'), parentReloadData: d => { 
      this.load_ticket_data(true)
     } };
     if(this.navParams.get('ticket_id'))
     {
      this.ticket_id=this.navParams.get('ticket_id');
      this.load_ticket_data(true);
     }

     //console.log(mm().format('MMMM Do YYYY, h:mm:ss a'));
  }

  saveComment()
  {
    this.summaryService.post_data('ticket/comment/'+this.ticket_id,{"text":this.comment_text}).then(() =>{
      this.load_ticket_data('false');
      this.comment_text="";
    })
  }



  updateTicketStatus(status)
  {

    let alert = this.alertCtrl.create({
      title: 'Alert',
      message: 'Please make sure ticket is resolved, Area You sure to close this ticket?',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Yes',
          handler: () => {
            this.summaryService.update_data('ticket/'+this.ticket_id,{"status":status}).then(() =>{
              this.load_ticket_data('false');
              this.comment_text="";
            })
          }
        }
      ]
    });
    alert.present();


   
  }


  


  load_ticket_data(show_loader) {


    let q: any = '';
    this.cp_data_obj=[];
    this.cp_data = '';
 
    if (this.ticket_id !== '') {
      q += 'ticket_id=' + this.ticket_id;
    }

    if (show_loader) {
      let loader = this.loadingCtrl.create({
        content: "Please wait..."
      });
      loader.present();

      this.summaryService.load_tickets_data(q)
        .then(data => {
          this.cp_data = data;
          this.cp_data_obj=this.cp_data.data.content[0];

          //console.log(this.dashboard_data);
        });

      loader.dismiss();
    }
    else {
      this.summaryService.load_tickets_data(q)
        .then(data => {
          this.cp_data = data;
          this.cp_data_obj=this.cp_data.data.content[0];
          //console.log(this.dashboard_data);
        });
    }

  }
}


// WEBPACK FOOTER //
// ./src/pages/backoffice/tickets/details/details.ts